import { Box, Container, Stack } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { String } from "../../constants/Strings";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { ReactComponent as FinancialSVG } from "../../assets/img/finanicaldetailpage.svg";
import { getColor } from "../../style/color/color";
import ACRButton from "../../commanComponents/ACRButton";
import { useLocation, useNavigate } from "react-router-dom";
import CommanButton from "../../commanComponents/CommanButton";

import {
  acrButtonStyle,
  commanButtomStyled,
  StyledDivider,
  StyledQuestionTypography,
  StyledTextContent,
} from "../../style/styleComponents/StyledFinancialDetails";
import IncomeSlider from "./IncomeSlider";

import { AuthContext } from "../../Hooks/context/AuthContext";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import useFinancialDetails from "../../Hooks/CustomHooks/useFinancialDetails";
import { useLocalStorage } from "../../logic/LocalStorage/LocalStorage";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const FinanacialQuestion = () => {
  const [bgColor, setBgColor] = useState(
    getColor.ExtendedPalettesSummerSkySS100
  );
  const [activeButton, setActiveButton] = useState(null);
  const [investmentStyleText, setInvestmentStyleText] = useState("");
  const {
    monthlySalary,
    monthlySaving,
    saveFinancialData,
    setmonthlySalary,
    setmonthlySaving,
    snackbarOpen,
    snackbarmessage,
    setSnackbarOpen,
  } = useFinancialDetails();

  const { authTokens } = useContext(AuthContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { retrieveLocalFinancialData } = useLocalStorage();
  const navigation = useNavigate();
  const location = useLocation();

  const { userId } = authTokens;
  const maxProgressValue = 1000000;

  //selction of mode of investment
  const handleClick = (buttonId) => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioInvestmentStyleEntered, verifyData.customerId);

    setBgColor(getColor.SecondaryMidnightBlue);
    setActiveButton(buttonId);
    if (buttonId === "Aggressive") {
      setInvestmentStyleText(String.Monthlyincome.investmentStyleAggressive);
      return;
    }
    if (buttonId === "Moderate") {
      setInvestmentStyleText(String.Monthlyincome.investmentStyleModerate);
    }
    if (buttonId === "Conservative") {
      setInvestmentStyleText(String.Monthlyincome.investmentStyleConservative);
    }
  };
  //Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  //retrive data from local on mount and fill
  useEffect(() => {
    const retrieveSavedData = async () => {
      try {
        const savedData = await retrieveLocalFinancialData(
          `financialData-${userId}`
        );
        if (savedData) {
          setmonthlySalary(savedData.monthlySalary);
          setmonthlySaving(savedData.monthlySaving);
          setActiveButton(savedData.investmentStyle);
        }
      } catch (error) { }
    };
    retrieveSavedData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleContineu = async (e) => {
    e.preventDefault();

    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioContinue, verifyData.customerId);

    const success = await saveFinancialData(userId, activeButton);
    if (success) {
      setTimeout(() => {
        navigation(String.navigations.goal);
      }, 2000);
    }
  };

  return (
    <Container>
      <PageTitle PageTitle={String.Monthlyincome.Title} />
      <LinearProgressBar
        progress={25}
        progressNumber={25}
        stepNumber={2}
        dragMessage={String.Monthlyincome.DragBarSLiderMessage}
      />
      <Stack
        sx={{
          justifyContent: "center",
          alignItems: "center",
          mt: { xs: "10%", md: "30%" },
          mb: "80px",
        }}
      >
        <FinancialSVG
          style={{
            width: "100%",
            maxWidth: "350px",
            objectFit: "contain",
          }}
        />
      </Stack>
      <IncomeSlider
        question={String.Monthlyincome.question1}
        maxProgressValue={maxProgressValue}
        income={monthlySalary}
        setIncome={(value) => {
          gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioIncomeEntered, verifyData.customerId);
          setmonthlySalary(value);
          if (value && value !== 0) {
            const averageSaving = (value * 30) / 100;

            setmonthlySaving(averageSaving.toFixed(0));
          } else {
            setmonthlySaving("");
          }
        }}
        placeholder={String.Monthlyincome.incomePlaceholder}
      />{" "}
      <StyledDivider />
      <IncomeSlider
        question={String.Monthlyincome.question2}
        maxProgressValue={maxProgressValue}
        income={monthlySaving}
        setIncome={(value) => {
          gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioSavingsEntered, verifyData.customerId);
          setmonthlySaving(value);
        }}
        placeholder={String.Monthlyincome.savingPlaceholder}
      />
      <StyledDivider />
      <Box sx={{ mt: "30px", display: "flex", flexDirection: "column" }}>
        <StyledQuestionTypography>
          {String.Monthlyincome.question3}
        </StyledQuestionTypography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",

            alignItems: "center",
            mt: { xs: "30px", sm: "20px" },
          }}
        >
          <CommanButton
            label={String.Monthlyincome.ButtonAggressive}
            style={commanButtomStyled(activeButton, "Aggressive", bgColor)}
            onClickButton={() => {
              handleClick("Aggressive");
            }}
          />
          <CommanButton
            label={String.Monthlyincome.ButtonModerate}
            style={commanButtomStyled(activeButton, "Moderate", bgColor)}
            onClickButton={() => {
              handleClick("Moderate");
            }}
          />
        </Box>

        <Box sx={{ display: "flex", justifyContent: "center", mt: "5px" }}>
          <CommanButton
            label={String.Monthlyincome.ButtonConversion}
            style={commanButtomStyled(activeButton, "Conservative", bgColor)}
            onClickButton={() => {
              handleClick("Conservative");
            }}
          />
        </Box>
        <StyledTextContent variant="subtitle2">
          {investmentStyleText}
        </StyledTextContent>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ACRButton
          label={String.continue}
          style={acrButtonStyle}
          onClickButton={handleContineu}
        />
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => {
          setSnackbarOpen(false);
        }}
        message={snackbarmessage.message}
        severity={snackbarmessage.severity}
      />
    </Container>
  );
};

export default FinanacialQuestion;
